import { Menu } from "domain/menuOptions";

import { Col } from "reactstrap";
import { Navigation } from "../Page/Navigation";

type PageKitProps = {
  selectedMenu: Menu;
  menus: Menu[];
};
export const PageKit = ({ selectedMenu, menus }: PageKitProps) => {
  return (
    <>
      <Col className="nav-main" lg="auto" md="auto">
        <Navigation selectedMenu={selectedMenu} menus={menus} />
      </Col>
    </>
  );
};
